
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Setting extends Vue {
    @Prop({ type: Number, default: 0 })
    type!: number;

    invoice = [
        {
            title: "凭证生成"
        },
        {
            type: "radio",
            label: "是否生成标准科目（若不生成将影响纳税申报表的取数）?",
            keyword: "INVOICE_AUTO",
            value: 0
        },
        {
            title: "凭证摘要"
        },
        {
            type: "checkbox",
            label: "摘要类型：",
            children: [
                {
                    label: "开票日期",
                    keyword: "INVOICE_DATE",
                    value: 0
                },
                {
                    label: "单位名称",
                    keyword: "INVOICE_NAME",
                    value: 0
                },
                {
                    label: "单位全称",
                    keyword: "INVOICE_FULL_NAME",
                    value: 0
                },
                {
                    label: "开票项目",
                    keyword: "INVOICE_ITEM",
                    value: 0
                },
                {
                    label: "金额",
                    keyword: "INVOICE_BALANCE",
                    value: 0
                },
                {
                    label: "发票号码",
                    keyword: "INVOICE_NO",
                    value: 0
                },
                {
                    label: "发票类型",
                    keyword: "INVOICE_TYPE",
                    value: 0
                },
                {
                    label: "备注",
                    keyword: "INVOICE_REMARK",
                    value: 0
                },
            ]
        },
        {
            type: "example",
            label: "摘要样例：",
            value: `如选择  开票日期+单位名称+开票项目+金额+发票号码+发票类型。\n生成摘要为：销售#03-21#xx公司#某某商品#¥10000#320011234#专票`
        },
        {
            title: "单位设置"
        },
        {
            type: "radio",
            label: "是否根据增值税发票单位自动设置科目单位?",
            keyword: "INVOICE_UNIT",
            value: 0
        },
    ];

    journal = [
        {
            title: "凭证摘要"
        },
        {
            type: "checkbox",
            label: "摘要类型：",
            children: [
                {
                    label: "收支日期",
                    keyword: "JOURNAL_DATE",
                    value: 0
                },
                {
                    label: "对方户名",
                    keyword: "JOURNAL_NAME",
                    value: 0
                },
                {
                    label: "金额",
                    keyword: "JOURNAL_BALANCE",
                    value: 0
                },
                {
                    label: "日记账摘要",
                    keyword: "JOURNAL_SUMMARY",
                    value: 0
                },
            ]
        },
        {
            type: "example",
            label: "摘要样例：",
            value: `如选择  收支日期+单位名称+金额\n生成摘要为：银01-21收到投资款#xx公司#¥10000`
        }
    ];

    other = [
        {
            title: "凭证摘要"
        },
        {
            type: "checkbox",
            label: "摘要类型：",
            children: [
                {
                    label: "金额",
                    keyword: "OTHER_INVOICE_BALANCE",
                    value: 0
                },
                {
                    label: "备注",
                    keyword: "OTHER_INVOICE_REMARK",
                    value: 0
                },
            ]
        },
        {
            type: "example",
            label: "摘要样例：",
            value: `如选择  金额  \n生成摘要为：报销日常费用#¥10000`
        }
    ];

    paySheet = [
        {
            title: "凭证生成"
        },
        {
            type: "radio",
            label: "是否生成标准凭证?",
            keyword: "PAY_SHEET_AUTO",
            value: 0
        },
    ];

    dataList: any[] = [];
    created() {
        this.fetchData();
    }

    async fetchData() {
        let category = "invoice";
        switch (this.type) {
            case 0:
                this.dataList = this.invoice;
                category = "invoice";
                break;
            case 1:
                this.dataList = this.journal;
                category = "journal";
                break;
            case 2:
                this.dataList = this.other;
                category = "otherInvoice";
                break;
            case 3:
                this.dataList = this.paySheet;
                category = "paySheet";
                break;
        }
        const res = await Vue.axios.get(`systemsettings/find/list?accountBookId=${this.$store.state.accountBook.id}&category=${category}`);
        res.data.forEach((v: any) => {
            for (let i = 0; i < this.dataList.length; i++) {
                const data = this.dataList[i];
                if (data.keyword && v.keyword === data.keyword) {
                    data.value = +v.value;
                }
                if (data.children) {
                    for (let j = 0; j < data.children.length; j++) {
                        const child = data.children[j];
                        if (child.keyword && v.keyword === child.keyword) {
                            child.value = +v.value;
                        }
                    }
                }
            }
        });
    }

    async changeRadio(data: { keyword: string; value: number; }) {
        const res = await Vue.axios.post(`systemsettings/save`, {
            accountBookId: this.$store.state.accountBook.id,
            keyword: data.keyword,
            value: data.value,
        });
        data.value = +res.data.value;
    }

    async changeCheck(data: { keyword: string; value: number; }) {
        const res = await Vue.axios.post(`systemsettings/save`, {
            accountBookId: this.$store.state.accountBook.id,
            keyword: data.keyword,
            value: data.value,
        });
        data.value = +res.data.value;
    }
}
